<div class="vtr-ui-list-checkbox">
	<!-- update list with checkbox section -->
	<ul class="list-group"
		*ngIf="!isInstallationCompleted && !isUpdateDownloading">
		<li class="list-group-item"
			id="su_item_candidate"
			*ngFor="let item of items; let i = index"
			[ngClass]="{'selected': item.isSelected}">
			<div class="custom-control">
				<vtr-material-checkbox
					componentId="{{ 'updateCheckbox_'  + item.packageID }}"
					[disabled]="item.isDependency"
					[checked]="item.isSelected"
					[value]="item.isSelected"
					(toggle)="onCheckChange($event, item)"
					[hasChild]="true">
					<div class="row"
						id="{{'su_item_' + item.packageID}}"
						role="text">
					<span class="update-title col-auto">
						{{item.packageDesc}}</span>
					<div class="button-box col-12 col-md-auto col-lg-12 col-xl-auto"
						*ngIf="item.packageRebootType === 'RebootForced'">
						<div class="btn-round-sm"
							id="{{'su_rebootForced_'+item.packageID}}"
							role="text">
							<fa-icon [icon]="['fas', 'redo']"></fa-icon>
							{{'systemUpdates.updateCheckbox.rebootRequiredTag' | translate}}
						</div>
					</div>
					<div class="button-box col-12 col-md-auto col-lg-12 col-xl-auto"
						*ngIf="item.packageRebootType === 'RebootDelayed'">
						<div class="btn-round-sm"
							id="{{'su_rebootDelayed_'+item.packageID}}"
							role="text">
							<fa-icon [icon]="['fas', 'redo']"></fa-icon>
							{{'systemUpdates.updateCheckbox.rebootDelayTag' | translate}}
						</div>
					</div>
					<div class="button-box col-12 col-md-auto col-lg-12 col-xl-auto"
						*ngIf="item.packageRebootType === 'PowerOffForced'">
						<div class="btn-round-sm"
							id="{{'su_powerOffForced_'+item.packageID}}"
							role="text">
							<fa-icon [icon]="['fas', 'redo']"></fa-icon>
							{{'systemUpdates.updateCheckbox.shutdownRequiredTag' | translate}}
						</div>
					</div>
					<div class="button-box col-12 col-md-auto col-lg-12 col-xl-auto"
						*ngIf="item.isDependency">
						<div class="btn-round-sm"
							id="{{'su_depended_'+item.packageID}}"
							role="text">
							<fa-icon [icon]="['fas', 'redo']"></fa-icon>
							{{'systemUpdates.updateCheckbox.dependedPackage' | translate}}
						</div>
					</div>
					<span [dir]="'dir' | translate" role="text"
						id="{{'su_download_size_' + item.packageID}}"
						class="update-subtitle col-12 p-0">
						{{'systemUpdates.updateCheckbox.downloadSize' | translate}}
						{{ getFormatedDownloadSize(item.packageSize) }}
					</span>
				</div>
				</vtr-material-checkbox>
			</div>
			<fa-icon
				class="question"
				tabindex="0"
				id="{{'su_item_question_mark_' + item.packageID}}"
				[matPopupTriggerFor]="systemUpdateTooltip"
				(menuOpened)="onTooltipClick(item)"
				[icon]="['far', 'question-circle']"
				role="tooltip"
			></fa-icon>
		</li>
	</ul>
	<!-- Installation completed section -->
	<ul class="list-group"
		*ngIf="isInstallationCompleted || isUpdateDownloading">
		<li class="list-group-item"
			id="{{'su_item_installed_' + item.packageID}}"
			*ngFor="let item of items">
			<div class="media pl-3 align-items-center w-100">
				<div *ngIf="isInstallationCompleted">
					<div *ngIf="item.installationStatus === UpdateActionResult.Success; else elseBlock">
						<div class="icon-check">
							<div class="icon-bg text-center">
								<fa-icon id="{{'su_item_installed_icon_success_' + item.packageID}}"
									role="text"
									[icon]="['fas', 'check']"></fa-icon>
							</div>
						</div>
					</div>
					<ng-template #elseBlock>
						<div class="icon-times">
							<div class="icon-bg text-center">
								<fa-icon id="{{'su_item_installed_icon_failure_' + item.packageID}}"
									role="text"
									[icon]="['fas', 'times']"></fa-icon>
							</div>
						</div>
					</ng-template>
				</div>
				<div class="media-body pb-0 mb-0 small pl-3">
					<!---div class="d-flex justify-content-between align-items-center w-100"-->
					<div class="row align-items-center">
						<div class="col item-text">
							<div class="row"
								id="{{'su_item_installed_description_' + item.packageID}}"
								role="text">
								<div class="d-flex justify-content-between align-items-center w-100">
									<div class="update-title">{{item.packageDesc}}</div>
								</div>
							</div>
							<div class="row"
								id="{{'su_item_installed_failReason_' + item.packageID}}"
								role="text">
								<div class="col">
									<div class="d-flex justify-content-between align-items-center w-100">
										<div class="fail-reason"
											*ngIf="item.installationStatus === UpdateActionResult.InstallFailed && !item.isACAttached && item.packageRebootType.toLocaleLowerCase() === 'rebootdelayed'">
											{{'systemUpdates.updateCheckbox.failReason' | translate}}</div>
									</div>
								</div>
							</div>
						</div>
						<fa-icon class="question"
							tabindex="0"
							id="{{'su_item_installed_question_mark_' + item.packageID}}"
							[matPopupTriggerFor]="systemUpdateTooltip"
							[icon]="['far', 'question-circle']"
							(menuOpened)="onTooltipClick(item)"
							role="tooltip"
						></fa-icon>
					</div>
				</div>
			</div>
		</li>
	</ul>
</div>
<mat-menu #systemUpdateTooltip="matMenu" [hasBackdrop]="false" class="vtr-tooltip" xPosition="before" yPosition="center">
	<div mat-menu-item>
		<ul class="tooltip-container" [dir]="'dir' | translate">
			<li *ngIf="manufacturer && manufacturer !== undefined" id="{{'su-package-manufacturer-'+ packageID}}">{{'systemUpdates.updateCheckbox.manufacturer' | translate}}<span>{{ manufacturer }}</span></li>
			<li id="{{'su-package-version-'+ packageID}}">{{'systemUpdates.updateCheckbox.version' | translate}}<span>{{ version }}</span></li>
			<li *ngIf="!isInstallationCompleted && !isUpdateDownloading && installedVersionStatus === 0" id="{{'su-package-installedVersion-'+ packageID}}">{{'systemUpdates.updateCheckbox.installVersion' | translate}}<span>{{ installedVersion }}</span></li>
			<li *ngIf="!isInstallationCompleted && !isUpdateDownloading && installedVersionStatus === 1" id="{{'su-package-notInstalledText-'+ packageID}}">{{'systemUpdates.updateCheckbox.installVersion' | translate}}<span>{{ notInstalledText }}</span></li>
			<li *ngIf="!isInstallationCompleted && !isUpdateDownloading && installedVersionStatus === 2" id="{{'su-package-notAvailableText-'+ packageID}}">{{'systemUpdates.updateCheckbox.installVersion' | translate}}<span>{{ notAvailableText }}</span></li>
			<li *ngIf="diskSpaceNeeded  && manufacturer !== undefined" id="{{'su-package-diskSpaceNeeded-'+ packageID}}">{{'systemUpdates.updateCheckbox.diskSpaceNeeded' | translate}}<span>{{ diskSpaceNeeded }}</span></li>
		</ul>
		<div class="row px-2"
			*ngIf="isReadMeAvailable || severity !== UpdateInstallSeverity.Critical">
			<div class="pl-2 pr-3 text-left"
				*ngIf="isReadMeAvailable">
				<a mat-menu-item href="javascript:void(0)"
					tabindex="0"
					class="tooltip-link"
					id="{{'su-package-readme-'+ packageID}}"
					(click)="onReadMoreClick($event)"
					(keydown.enter)="onReadMoreClick($event)">{{'systemUpdates.readMore' | translate}}</a>
			</div>
			<!-- required in MVP 2 -->
			<div class="pl-0 pr-0 text-left"
				*ngIf="severity !== UpdateInstallSeverity.Critical && isIgnored === false && !isInstallationCompleted && !isUpdateDownloading">
				<a mat-menu-item href="javascript:void(0)"
					class="tooltip-link"
					tabindex="0"
					id="{{'su-ignore-update-'+ packageID}}"
					(click)="onIgnoreUpdateClick(packageName, true, severity)"
					(keyup.enter)="onIgnoreUpdateClick(packageName, true, severity)">{{'systemUpdates.updateCheckbox.ignore' | translate}}</a>
			</div>
			<div class="pl-0 pr-0 text-left"
				*ngIf="severity !== UpdateInstallSeverity.Critical && isIgnored === true && !isInstallationCompleted && !isUpdateDownloading">
				<a mat-menu-item href="javascript:void(0)"
					class="tooltip-link"
					tabindex="0"
					id="{{'su-attend-update-'+ packageID}}"
					(click)="onIgnoreUpdateClick(packageName, false, severity)"
					(keyup.enter)="onIgnoreUpdateClick(packageName, false, severity)">{{'systemUpdates.updateCheckbox.attend' | translate}}</a>
			</div>
		</div>
	</div>
</mat-menu>
